import { clientToInvoiceableEntity } from "components/Invoicing/invoiceAdapter";
import InvoiceContainer from "components/Invoicing/InvoiceContainer";
import LoadingIcon from "components/Loading/LoadingIcon";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useGetClientByIdQuery } from "services/client-api";

import ClientDocumentsDrawer from "./ClientDocumentsDrawer/ClientDocumentsDrawer";

type Section111InvoicingPageParams = {
  clientId: string;
};

const Section111InvoicingPage = () => {
  const { clientId } = useParams<Section111InvoicingPageParams>();

  const { data: client, isLoading } = useGetClientByIdQuery({
    id: clientId,
  });

  const invoiceableEntity = useMemo(() => {
    if (!client) return null;
    return clientToInvoiceableEntity(client);
  }, [client]);

  if (isLoading || !client) {
    return <LoadingIcon />;
  }

  return (
    <>
      <div className="section-111-invoicing-page">
        {invoiceableEntity && (
          <InvoiceContainer
            entity={invoiceableEntity}
            config={{
              showHistory: true,
              invoiceType: "file_service",
            }}
            invoiceType="file_service"
          />
        )}
      </div>
      <ClientDocumentsDrawer />
    </>
  );
};

export default Section111InvoicingPage;
